import { PropType, computed, defineComponent } from 'vue'
import { Store } from 'pinia'
import { ChargeMapContext } from '../../chargerMap/index.model'
import { ComponentActions, ComponentState } from '../../../nsh5/localStores/component'
import { MapViewMode } from '../../../contract/map'
import NewStationRender from './newStationRender'

export default defineComponent({
  name: 'new-station-dot-render-view',
  props: {
    mapContextRef: {
      type: Object as PropType<ChargeMapContext>,
    },
    mapInstance: {
      type: Object,
    },
    componentStore: {
      // 用于同一项目功能模块间的通信
      type: Object as PropType<Store<string, ComponentState, {}, ComponentActions>>,
      default: null,
    },
  },

  setup: (props, { expose }) => {
    const mapContextRef = computed(() => props.mapContextRef)
    const mapInstance = computed(() => props.mapInstance)
    const componentStore = computed(() => props.componentStore)

    return () => (
      <>
        {componentStore.value.viewMode === MapViewMode.NewStation && (
          <>
            <NewStationRender
              mapContextRef={mapContextRef.value}
              mapInstance={mapInstance.value}
              componentStore={componentStore.value}
            ></NewStationRender>
          </>
        )}
      </>
    )
  },
})
